import { notification } from 'antd';
import React, { Component } from 'react'
import { getSegmento } from '../../util/generics';

/**
 * Clase para mostrar la bienvenida al usuario
 */
class Home extends Component {

    componentDidMount(){
        
        if (!getSegmento()) {
            this.openNotificationWithIcon('error', "No cuenta con segmento asignado. Contacte al administrador.")
        }
    }

    /**
     * Función que se ejecuta cuando hay un error
     * @param: type. valor de la notificación
     * @return: nada.
     */
    openNotificationWithIcon = (type, message) => {
        notification[type]({
            message: 'Error',
            description: message,
        });
    };

    render() {
        return (
            <div>
                <h1 style={{ textAlign: "center", marginTop: 40, marginBottom: 10, fontSize: 26 }}>Hola {localStorage.getItem("name")}, bienvenido al Sistema de Inventario.</h1>
                <h1 style={{ textAlign: "center", marginTop: 10, marginBottom: 70, fontSize: 20 }}>Usted ha iniciado sesión con los roles de {localStorage.getItem("role")?.split(",").join(', ')}</h1>
            </div>
        )
    }
}

export default Home;